import React from "react";

const Footer = () => {
  return (
    <div>
      <footer>
        <h4>
        Inshorts Clone
      
        </h4>
      </footer>
    </div>
  );
};

export default Footer;
